import React from "react";
import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import { pt } from "date-fns/locale";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    pt: 2,
    pb: 2,
    minWidth: { xs: 320, sm: 500, md: 700, lg: 850 },
    maxWidth: { xs: '90vw', sm: 850 },
    borderRadius: 4,
    position: "relative",
    outline: 'none',
};

const formatXml = (xml) => {
    let formatted = '';
    let reg = /(>)(<)(\/*)/g;
    xml = xml.replace(reg, '$1\r\n$2$3');
    let pad = 0;
    xml.split('\r\n').forEach((node) => {
        let indent = 0;
        if (node.match(/.+<\/\w[^>]*>$/)) {
            indent = 0;
        } else if (node.match(/^<\/\w/)) {
            if (pad !== 0) {
                pad -= 1;
            }
        } else if (node.match(/^<\w[^>]*[^\/]>.*$/)) {
            indent = 1;
        } else {
            indent = 0;
        }

        let padding = '';
        for (let i = 0; i < pad; i++) {
            padding += '  ';
        }

        formatted += padding + node + '\r\n';
        pad += indent;
    });

    return formatted.trim();
};


export default function MotivoRechazoModal({ open, setOpen, motivo }) {
    // Si motivo es un string que parece un JSON, lo parseamos
    let motivoObj = null;
    let isXML = false;
    if (typeof motivo === 'string') {
        // Detectar si es XML: empieza por < y contiene > y alguna etiqueta
        const xmlRegex = /^\s*<\?xml[\s\S]*\?>|<([a-zA-Z_][\w\-\.]*)[\s>]/;
        if (xmlRegex.test(motivo)) {
            isXML = true;
        } else {
            try {
                motivoObj = JSON.parse(motivo);
            } catch {
                motivoObj = null;
            }
        }
    } else if (typeof motivo === 'object' && motivo !== null) {
        motivoObj = motivo;
    }

    function renderMotivoContent() {
        if (isXML && typeof motivo === 'string') {
            return (
                <pre style={{
                    textAlign: 'left',
                    borderRadius: 4,
                    padding: 12,
                    fontSize: 15,
                    overflowX: 'auto',
                    margin: 0,
                }}>{formatXml(motivo)}</pre>
            );
        }
        if (motivoObj) {
            return (
                <pre style={{
                    textAlign: 'left',
                    background: '#f4f4f4',
                    borderRadius: 4,
                    padding: 12,
                    fontSize: 15,
                    overflowX: 'auto',
                    color: '#222',
                    margin: 0
                }}>{JSON.stringify(motivoObj, null, 2)}</pre>
            );
        }
        if (motivo) {
            return <span>{motivo}</span>;
        }
        return <span style={{ color: '#888' }}>No hay motivo de rechazo disponible.</span>;
    }

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
                    <h2 style={{ fontFamily: 'AdminFontMedium, Raleway, sans-serif', fontWeight: 600, marginBottom: 16, fontSize: 23 }}>
                        Respuesta Verifactu
                    </h2>
                    <Box sx={{
                        fontFamily: 'AdminFontRegular, Raleway, sans-serif',
                        fontSize: 18,
                        color: '#222',
                        background: '#f8f8fa',
                        p: 2,
                        minHeight: 60,
                        mb: 3,
                        border: '1px solid #eee',
                    }}>
                        {renderMotivoContent()}
                    </Box>
                    <Button
                        onClick={() => setOpen(false)}
                        variant="contained"
                        className="MuiButton-containedCancel"
                        sx={{
                            mt: 2,
                            px: 2,
                            width: 200
                        }}
                    >
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
